import React, { useEffect, useRef } from "react";

// Muted looping background video; sets `muted` via the DOM so mobile autoplay is allowed.
export function LoopVideo({ src, poster, className, label, testid, style }) {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v) return undefined;
    v.muted = true;
    v.defaultMuted = true;
    const play = () => { v.play().catch(() => {}); };
    play();
    v.addEventListener("canplay", play);
    return () => v.removeEventListener("canplay", play);
  }, [src]);
  return (
    <video ref={ref} src={src} poster={poster} className={className} style={style} autoPlay muted loop playsInline
      preload="auto" aria-label={label} data-testid={testid} />
  );
}
